import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

// ViewBox: 0 0 84 84
// All 3 shapes: M + 8× "C cx cy cx cy x y" + Z = identical command structure
// Arch: doorway shape — flat bottom, semicircular top, soft bottom corners
// TriUp / TriDn: triangles with rounded corners (r≈10)

const arch =
  "M 17.1 0.3 c 7.4 0 13.3 5.9 13.3 13.2 v 11.4 c 0 1 -0.8 1.8 -1.8 1.8 H 5.5 c -1 0 -1.8 -0.8 -1.8 -1.8 v -11.4 C 3.7 6.2 9.7 0.3 17.1 0.3 Z";

const triUp =
  "M 18.5 1.2 l 13.6 22.6 c 0.8 1.3 -0.2 2.9 -1.6 2.9 h -27.2 c -1.5 0 -2.4 -1.6 -1.6 -2.9 L 15.2 1.2 c 0.7 -1.2 2.5 -1.2 3.3 0 Z";

const triDn =
  "M 15.1 25.8 L 1.5 3.2 c -0.8 -1.3 0.2 -2.9 1.6 -2.9 h 27.2 c 1.5 0 2.4 1.6 1.6 2.9 l -13.6 22.6 c -0.7 1.2 -2.5 1.2 -3.3 0 Z";

const Preloader = () => {
  const [showLogo, setShowLogo] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShowLogo(false), 4000);
    return () => clearTimeout(t);
  }, []);

  const anim = {
    duration: 2,
    repeat: 1,
    ease: "easeInOut",
  };

  return (
    <motion.div
      initial={{ opacity: 1, pointerEvents: "auto" }}
      animate={{
        opacity: showLogo ? 1 : 0,
        pointerEvents: showLogo ? "auto" : "none",
      }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 10,
        background: "rgba(249, 240, 223, 0.9)",
        backdropFilter: "saturate(0%) blur(10px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg viewBox="0 0 27 27" style={{ width: 100, height: "100%", overflow: "visible" }}>
        {/* triDn — back layer */}
        <motion.path
          d={triDn}
          fill="#a45826"
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 0] }}
          transition={{ ...anim, times: [0.5, 0.75, 1] }}
          style={{ translateX: 20 }}
        />
        {/* triUp — middle layer */}
        <motion.path
          d={triUp}
          fill="#115945"
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 0] }}
          transition={{ ...anim, times: [0.25, 0.5, 0.75] }}
          style={{}}
        />
        {/* arch — front layer */}
        <motion.path
          d={arch}
          fill="#dd9331"
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 0] }}
          transition={{ ...anim, times: [0, 0.25, 0.5] }}
          style={{ translateX: -30 }}
        />
      </svg>
    </motion.div>
  );
};

export default Preloader;
